import { useAtom } from 'jotai';
import { useCallback, useEffect } from 'react';

import { preSessionVibesTutorialCompletedAtom, visitorDrawerStateAtom } from '../../state';
import { MusicStateToggleButtonWrapper as MusicStateToggleButton } from '../background-action/MusicStateToggleButtonWrapper';
import { KeyboardWrapper as Keyboard } from './KeyboardWrapper';
import { VerticalVibes } from './VerticalVibes';
import { SHOW_ALL_BODY_CLASS, TUTORIAL_BODY_CLASS, TUTORIAL_KEYS } from './constants';
import type { VibesComponentProps } from './types';

export function VerticalVibesWrapper(props: VibesComponentProps) {
  // Tracks whether the user has interacted with the keyboard.
  // Stored in global state so we persist this across navigation,
  // allowing us to skip instructions if they return.
  const [keyPlayed, setKeyPlayed] = useAtom(preSessionVibesTutorialCompletedAtom);
  const [visitorDrawerState, setVisitorDrawerState] = useAtom(visitorDrawerStateAtom);

  useEffect(
    function clearExistingDrawerState() {
      // Close any other open drawers to prevent weird overlap issues
      if (visitorDrawerState) {
        setVisitorDrawerState(null);
      }
    },
    [visitorDrawerState, setVisitorDrawerState],
  );

  const onKeyPlayed = useCallback(() => {
    if (!keyPlayed) {
      setKeyPlayed(true);
    }
  }, [keyPlayed, setKeyPlayed]);

  return (
    <VerticalVibes
      {...props}
      keyboardComponent={Keyboard}
      musicStateToggleButtonComponent={MusicStateToggleButton}
      onKeyPlayed={onKeyPlayed}
      keys={TUTORIAL_KEYS}
      bodyClassOverride={keyPlayed ? SHOW_ALL_BODY_CLASS : TUTORIAL_BODY_CLASS}
    />
  );
}
